import { ApiAuthResponse } from '../interfaces';
import { decodeAuthToken } from '../queries/ats/auth/api';
import { queryClient } from '../queries/client';
import { configQuery } from '../queries/config/queries';
import { tracker } from '../tracker';

export async function initializeUserTracker(auth: ApiAuthResponse, token: string) {
  tracker.reset();

  try {
    const config = await queryClient.fetchQuery(configQuery());
    const decodedToken = decodeAuthToken(token);
    await tracker.init(config, auth.bossID, auth.usergroup);
    await tracker.identifyUser(auth.userID, auth.bossID, parseInt(decodedToken.partnerId, 10));
  } catch (error) {
    tracker.reset();
    tracker.disable();
  }
}

export async function initializeGuestTracker(auth: ApiAuthResponse) {
  tracker.reset();

  try {
    const config = await queryClient.fetchQuery(configQuery());
    await tracker.init(config, auth.bossID, auth.usergroup);
  } catch (error) {
    tracker.reset();
    tracker.disable();
  }
}
